import { NativeFeatureIdentifier } from './NativeFeatureIdentifier';
import { serverFeatures } from '../Lists/ServerFeatures';
import { clientFeatures } from '../Lists/ClientFeatures';
import { GetDeprecatedFeatures } from '../Lists/DeprecatedFeatures';
import { experimentalFeatures } from '../Lists/ExperimentalFeatures';
import { IframeEditors } from '../Lists/IframeEditors';
import { themes } from '../Lists/Themes';
import { nativeEditors } from '../Lists/NativeEditors';
import { ComponentArea } from '../Component/ComponentArea';
export function GetFeatures() {
    return [
        ...serverFeatures(),
        ...clientFeatures(),
        ...themes(),
        ...nativeEditors(),
        ...IframeEditors(),
        ...experimentalFeatures(),
        ...GetDeprecatedFeatures(),
    ];
}
export function FindNativeFeature(identifier) {
    return GetFeatures().find((f) => f.identifier === identifier);
}
export function FindNativeTheme(identifier) {
    return themes().find((t) => t.identifier === identifier);
}
export function GetIframeAndNativeEditors() {
    return [...IframeEditors(), ...nativeEditors()];
}
export function GetIframeEditors() {
    return IframeEditors();
}
export function GetSuperNoteFeature() {
    return FindNativeFeature(NativeFeatureIdentifier.TYPES.SuperEditor);
}
export function GetPlainNoteFeature() {
    return FindNativeFeature(NativeFeatureIdentifier.TYPES.PlainEditor);
}
export function GetNativeThemes() {
    return themes();
}
export function GetDarkThemeFeature() {
    return themes().find((t) => t.identifier === NativeFeatureIdentifier.TYPES.DarkTheme);
}
export function GetDeprecatedEditors() {
    return GetDeprecatedFeatures().filter((f) => f.area === ComponentArea.Editor);
}
